import { createSlice } from "@reduxjs/toolkit";

const dataAtual = new Date();
const dia = dataAtual.getDate()
const mes = dataAtual.getMonth() + 1
const ano = dataAtual.getFullYear()
const nomeDiaSemana = dataAtual.toLocaleDateString('pt-BR', { weekday: 'long' }); 
const adicionarZero = valor => valor < 10 ? `0${valor}` : valor;
const hora = adicionarZero(dataAtual.getHours());
const minutos = adicionarZero(dataAtual.getMinutes());

const initialState = {
    loading: true,
    saving: false,
    now : dataAtual.toISOString(),
    data : {
        dia : adicionarZero(dia), 
        mes : adicionarZero(mes), 
        ano,
        horario: `${hora}:${minutos}`,
        nome : nomeDiaSemana
    },
    session : {
        start: "2024-01-05T20:45:52.753Z",
        label: "-"
    },
    lap: null
}

export const timerSlice = createSlice({
    name: "timer",
    initialState,
    reducers: {
        triggerLoadTimer: () => { },
        setTimerAttr : (state, action) => {
            state[action.payload.campo] = action.payload.value
        },
        triggerResetSession : () => {},
        triggerTimerCounterTick : () => {},
        triggerStartLap : () => {},
        triggerPauseLap : () => {},
        triggerResumeLap : () => {},
        triggerStopLap : () => {},
        triggerResetLap : () => {},
    }
})

export const {
    triggerLoadTimer,
    setTimerAttr,
    triggerResetSession,
    triggerTimerCounterTick,
    triggerStartLap,
    triggerPauseLap,
    triggerResumeLap,
    triggerStopLap,
    triggerResetLap
} = timerSlice.actions;

export default timerSlice.reducer;